import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import {
	Card,
	Row,
	Col,
	FormControl,
	FormGroup,
	FormLabel,
	ButtonGroup,
	Button,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
	Accordion as PrimeAccordion,
	AccordionTab,
} from 'primereact/accordion';
import ptBR from 'date-fns/locale/pt-BR';
import DatePicker, { registerLocale } from 'react-datepicker';
import Spinner from '@atlaskit/spinner';

import Popout from '../../components/Popout';
import LoadingButton from '../../components/LoadingButton';
import { withUser } from '../../modules/User';
import api from '../../api';
import { toBrCurrency } from '../../utils/utils';

import NonPayment from './NonPayment';
// import RevenuesGoal from './RevenuesGoal';
import Wallet from './Wallet';
import Commission from './Commission';
import Potential from './Potential';
import IsLoadingDiv from './IsLoadingDiv';
import SalesGoalWrapper from './SalesGoalWrapper';
import './styles.scss';
// import WallerOverview from './WallerOverview';
import WeeklySalesGoal from './WeeklySalesGoal';
import Revenue from './Revenue';
import ServedCustomers from './ServedCustomers/ServedCustomers';

// https://www.npmjs.com/package/react-d3-speedometer
// https://nivo.rocks/pie/

/*
  <Charts
    cotaVendas={cotaVendas}
    cotaFaturamento={cotaFaturamento}
    comissao={comissao}
    carteira={carteira}
    nonPayment={nonPayment}
    isRepresentante={representante ? true : false}
  />
*/

registerLocale('ptBR', ptBR);

const defaultButtonStyle = {
	width: '100%',
};

const articleToOptions = ({ code, description }) => ({
	label: `${code} - ${description}`,
	value: code,
});

const commissionChartValue = ({ credit, debit, duplicate, order }) => {
	var chart = [];
	if (credit != null)
		chart.push({
			id: '1',
			label: `Crédito: R$ ${toBrCurrency(credit)}`,
			value: parseFloat(credit.toFixed(2)).toFixed(2),
		});
	if (debit != null)
		chart.push({
			id: '2',
			label: `Débito: R$ ${toBrCurrency(debit)}`,
			value: parseFloat(debit.toFixed(2)).toFixed(2),
		});
	if (order != null)
		chart.push({
			id: '3',
			label: `Prev. Pedido: R$ ${toBrCurrency(order)}`,
			value: parseFloat(order.toFixed(2)).toFixed(2),
		});
	if (duplicate != null)
		chart.push({
			id: '4',
			label: `Prev. Duplicata: R$ ${toBrCurrency(duplicate)}`,
			value: parseFloat(duplicate.toFixed(2)).toFixed(2),
		});
	return chart;
};

const walletChartValue = ({ open, blocked, expedition, canceled }) => {
	var chart = [];
	if (open != null)
		chart.push({
			id: '1',
			label: `Aberto: R$ ${toBrCurrency(open)}`,
			value: parseFloat(open.toFixed(2)).toFixed(2),
		});
	if (blocked != null)
		chart.push({
			id: '2',
			label: `Bloqueado: R$ ${toBrCurrency(blocked)}`,
			value: parseFloat(blocked.toFixed(2)).toFixed(2),
		});
	if (expedition != null)
		chart.push({
			id: '3',
			label: `Expedição: R$ ${toBrCurrency(expedition)}`,
			value: parseFloat(expedition.toFixed(2)).toFixed(2),
		});
	if (canceled != null)
		chart.push({
			id: '4',
			label: `Cancelado: R$ ${toBrCurrency(canceled)}`,
			value: parseFloat(canceled.toFixed(2)).toFixed(2),
		});
	return chart;
};

const collectionChartValue = ({
	releasedCredit,
	nrCliRelCred,
	insufficientCredit,
	nrCliInsCred,
	suspendedCredit,
	nrCliSusCred,
	withoutCredit,
	nrCliWithoutCred,
	debitBalance,
	nrCliDebBalance,
}) => {
	var chart = [];
	if (releasedCredit != null)
		chart.push({
			id: '1',
			label: `Lm. Projetado: ${nrCliRelCred}`,
			value: parseFloat(releasedCredit.toFixed(2)).toFixed(2),
		});
	if (insufficientCredit != null)
		chart.push({
			id: '2',
			label: `Lm. Insuficiente: ${nrCliInsCred}`,
			value: parseFloat(insufficientCredit.toFixed(2)).toFixed(2),
		});
	if (suspendedCredit != null)
		chart.push({
			id: '3',
			label: `Lm. Suspenso: ${nrCliSusCred}`,
			value: parseFloat(suspendedCredit.toFixed(2)).toFixed(2),
		});
	if (withoutCredit != null)
		chart.push({
			id: '4',
			label: `Sem Limite: ${nrCliWithoutCred}`,
			value: parseFloat(withoutCredit.toFixed(2)).toFixed(2),
		});
	if (debitBalance != null)
		chart.push({
			id: '5',
			label: `Dup. Aberto: ${nrCliDebBalance}`,
			value: parseFloat(debitBalance.toFixed(2)).toFixed(2),
		});
	return chart;
};

const getValueFromOption = ({ value }) => value;

const getFirstDay = (date) => {
	var newDate = new Date(date);
	var firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
	return firstDay;
};

const getLastDay = (date) => {
	var newDate = new Date(date);
	var lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
	return lastDay;
};

const dateFixed = (date) => new Date(date).toISOString().split('T')[0];

const tips = {
	inadimplencia:
		'Inadimplência: Percentual calculado dos títulos em aberto sobre o valor faturado nos anos indicados. <br> O faturamento considerado é o liquido, descontando cancelamentos e devoluções. Este indicador não é influenciado pelo filtro de mês/ano.',
	metaVendas:
		'Meta x Venda: Acompanhamento do desempenho das vendas em relação a meta, conforme o mês consultado. <br> É possível analisar por coleção, para isso deve-se escolher no campo coleção.',
	metaFaturamento: '', // "Meta x Faturamento:  Quando for representante, o nome deve ser apenas FATURAMENTO. Neste caso, não precisa de explicação",
	carteira:
		'Carteira: Situação dos pedidos em aberto, independente do filtro de data da tela, <br> data de entrega ou data de emissão do pedido.',
	comissao:
		'Comissão: Indicador de previsão de comissão conforme o mês consultado nos filtros. <br> Funciona sempre do mês atual para frete, não sendo possível consultas retroativas. Para consulta de mês de comissão fechado deve-se usar a aba mapa de comissão.',
	colecoes: '',
};

const INITIAL_STATE = {
	// Isloading
	isLoadingNp: false,
	isLoadingPt: false,
	isLoadingSg: false,
	isLoadingRg: false,
	isLoadingWa: false,
	isLoadingCs: false,
	isLoadingCo: false,
	isLoadingSgp: false,

	// chart
	cotaVendas: null,
	cotaVendasPeriodo: null,
	cotaFaturamento: null,
	np: 'false',
	pt: 'false',
	sg: 'false',
	comissao: [
		{
			id: 'Crédito',
			label: 'Crédito',
			value: 1.0,
		},
		{
			id: 'Débito',
			label: 'Débito',
			value: 1.0,
		},
		{
			id: 'Prev. Pedido',
			label: 'Prev. Pedido',
			value: 1.0,
		},
		{
			id: 'Prev. Duplicata',
			label: 'Prev. Duplicata',
			value: 1.0,
		},
	],
	customerService: {},
	carteira: [
		{
			id: 'Aberto',
			label: 'Aberto',
			value: 1.0,
		},
		{
			id: 'Bloqueado',
			label: 'Bloqueado',
			value: 1.0,
		},
		{
			id: 'Expedição',
			label: 'Expedição',
			value: 1.0,
		},
		{
			id: 'Cancelado',
			label: 'Cancelado',
			value: 1.0,
		},
	],
	collection: [
		{
			id: 'Crédito Liberado',
			label: 'Lm. Projetado',
			value: 1.0,
		},
		{
			id: 'Crédito Insuficiente',
			label: 'Lm. Insuficiente',
			value: 1.0,
		},
		{
			id: 'Crédito Suspenso',
			label: 'Lm. Suspenso',
			value: 1.0,
		},
		{
			id: 'Sem Crédito',
			label: 'Sem Limite',
			value: 1.0,
		},
		{
			id: 'Saldo Devedor',
			label: 'Dup. Aberto',
			value: 1.0,
		},
	],

	// artigo de cotas
	articlesOptions: [],
	articlesSelected: [],

	// nonPayment
	nonPayment: {
		first: {
			year: 0,
			balance: 1,
			percentage: 1.0,
		},
		second: {
			year: 1,
			balance: 1,
			percentage: 1.0,
		},
	},

	// Filters
	// representante: '', // removido para não limpar representante ao rodar handleCLear
	searchedRepresentante: '',
	searchedCidade: [],
	searchedCliente: [],
	searchedSupervisor: [],
	// suggestionPriority: '',
	route: '',
	bought: false,
	requestDate: getFirstDay(Date.now()),
	requestDateFinal: getLastDay(Date.now()),

	// Page State
	isLoading: false,
	isSending: false,
	currentIndex: 0,
	activeIndex: 0,
};

class Charts extends Component {
	state = {
		...INITIAL_STATE,
		representante: this.props.userProps
			? this.props.userProps.representativeId
			: '',
	};

	// Lifecycle
	async componentDidMount() {
		await this.handleGetQuotaArticles();

		// Ao fazer login, ele já possui o representanteId nas userProps, então verifica se existe ou se é 0 (porque o id de supervisor vai ser 0 e 0 é tratado como false)
		// Caso alguma seja true então é executado o handleChart com o id de representante do usuário
		if (this.state.representante || this.state.representante === 0) {
			this.handleChart(this.state.representante);
		}
	}

	componentDidUpdate() {
		// Quando já está logado, ao entrar na pg a request de usuário ainda não vai ter retornado o ID do representante
		// Então, é necessário rodar um spinner (está lá no render) até que tenha um objeto de user
		// Quando entrar o objeto de user, o componentDidUpdate dispara e verifica se chego
		// Caso sim, verifica se existe repId ou se é igual a 0 E, se o representante no estado está vazio e é diferente de 0 (isso é importante para evitar loop de renderização)
		// E então, seta o representante no estado e executado o handleChart com o id de representante do usuário
		if (this.props.userProps) {
			const { representativeId } = this.props.userProps;
			if (
				(representativeId || representativeId === 0) &&
				!this.state.representante &&
				this.state.representante !== 0
			) {
				this.setState({ representante: representativeId });
				this.handleChart(representativeId);
			}
		}
	}

	// Handlers

	handleActiveIndex = (activeIndex) => this.setState({ activeIndex });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Input" da tela, para melhorar a
	 * visualização do código.
	 */
	handleFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Date" da tela, para melhorar a
	 * visualização do código.
	 */
	handleDateChange = (name, value) => this.setState({ [name]: value });

	handleRequestDate = (requestDate) =>
		this.setState({ requestDate: getFirstDay(requestDate) });

	handleRequestDateFinal = (requestDateFinal) =>
		this.setState({ requestDateFinal: getLastDay(requestDateFinal) });

	handleSearchedCidade = (searchedCidade) => this.setState({ searchedCidade });

	handleSearchedCliente = (searchedCliente) =>
		this.setState({ searchedCliente });

	handleSearchedSupervisor = (searchedSupervisor) =>
		this.setState({ searchedSupervisor });

	handleArticle = (articlesSelected) => this.setState({ articlesSelected });

	handleClear = () =>
		this.setState({
			...INITIAL_STATE,
			tabAtual: this.state.tabAtual,
			articlesOptions: this.state.articlesOptions,
			articlesSelected: this.state.articlesOptions,
		});

	// Request

	handleChart = async (representante) => {
		const {
			requestDate,
			searchedSupervisor,
			searchedRepresentante,
			articlesSelected,
		} = this.state;

		this.setState({
			isLoading: true,
			isLoadingNp: true,
			isLoadingPt: true,
			isLoadingSg: true,
			isLoadingSgp: true,
			isLoadingRg: true,
			isLoadingWa: true,
			isLoadingCs: true,
			isLoadingCo: true,
		});

		const rep = representante === 0 ? searchedRepresentante : representante;

		const paramRepresentativeId = {
			...(rep > 0 ? { representativeId: rep } : {}),
		};
		const paramSearchedSupervisor = {
			...(searchedSupervisor.length > 0
				? {
						supervisorId: searchedSupervisor.map(getValueFromOption).toString(),
				  }
				: {}),
		};
		const paramQuotaArticles = {
			...(articlesSelected.length > 0
				? { quotaArticles: articlesSelected.map(getValueFromOption).toString() }
				: {}),
		};

		const requestDateFixed = dateFixed(requestDate);

		try {
			// Inadimplencia
			const { data: nonPayment } =
				await api.comercial.charts.nonPayment.getNonPayment({
					params: { ...paramRepresentativeId },
				});
			this.setState({ isLoadingNp: false, nonPayment });
		} catch (err) {
			this.setState({ isLoadingNp: false });
			toast.error(`Erro ao consultar Inadimplência: ${err.message}`);
		}

		try {
			// MetaVendas
			const { data: cotaVendas } =
				await api.comercial.charts.goalSales.getGoalSales(requestDateFixed, {
					params: {
						...paramRepresentativeId,
						...paramSearchedSupervisor,
						...paramQuotaArticles,
					},
				});
			this.setState({ isLoadingSg: false, cotaVendas });
		} catch (err) {
			this.setState({ isLoadingSg: false });
			toast.error(`Erro ao consultar Meta Vendas: ${err.message}`);
		}

		try {
			// MetaVendas Periodo
			const { data: cotaVendasPeriodo } =
				await api.comercial.charts.goalSalesPeriod.getGoalSalesPeriod({
					params: {
						...paramRepresentativeId,
						...paramSearchedSupervisor,
						...paramQuotaArticles,
					},
				});
			this.setState({ isLoadingSgp: false, cotaVendasPeriodo });
		} catch (err) {
			this.setState({ isLoadingSgp: false });
			toast.error(`Erro ao consultar Meta Vendas por Período: ${err.message}`);
		}

		try {
			// MetaFaturamento
			const { data: cotaFaturamento } =
				await api.comercial.charts.goalRevenues.getGoalRevenues(
					requestDateFixed,
					{
						params: {
							...paramRepresentativeId,
							...paramSearchedSupervisor,
							...paramQuotaArticles,
						},
					},
				);
			this.setState({ isLoadingRg: false, cotaFaturamento });
		} catch (err) {
			this.setState({ isLoadingRg: false });
			toast.error(`Erro ao consultar Meta Faturamento: ${err.message}`);
		}

		try {
			// Carteira
			const { data: wallet } = await api.comercial.charts.wallet.getWallet({
				params: {
					...paramRepresentativeId,
					...paramSearchedSupervisor,
					...paramQuotaArticles,
				},
			});
			this.setState({
				isLoadingWa: false,
				carteira: wallet ? walletChartValue(wallet) : INITIAL_STATE.carteira,
			});
		} catch (err) {
			this.setState({ isLoadingWa: false });
			toast.error(`Erro ao consultar Carteira: ${err.message}`);
		}

		try {
			// Wallet Info
			const { data: customerService } =
				await api.comercial.customer.getCustomerOrdersServed(requestDateFixed, {
					params: {
						...paramRepresentativeId,
						...paramQuotaArticles,
					},
				});
			this.setState({
				isLoadingCs: false,
				customerService,
			});
		} catch (err) {
			this.setState({ isLoadingCs: false });
			toast.error(`Erro ao consultar Informações da Carteira: ${err.message}`);
		}

		try {
			// Comissao
			const { data: commission } =
				await api.comercial.charts.commission.getCommission(requestDateFixed, {
					params: { ...paramRepresentativeId, ...paramSearchedSupervisor },
				});
			this.setState({
				isLoadingCo: false,
				comissao: commission
					? commissionChartValue(commission)
					: INITIAL_STATE.comissao,
			});
		} catch (err) {
			this.setState({ isLoadingCo: false });
			toast.error(`Erro ao consultar Comissão: ${err.message}`);
		}

		try {
			// Potencial
			const { data: collection } = rep
				? await api.comercial.charts.collection.getCollection(
						requestDateFixed,
						{
							params: {
								...paramRepresentativeId,
								...paramSearchedSupervisor,
								...paramQuotaArticles,
							},
						},
				  )
				: false;
			this.setState({
				isLoadingPt: false,
				collection: collection
					? collectionChartValue(collection)
					: INITIAL_STATE.collection,
			});
		} catch (err) {
			this.setState({ isLoadingPt: false });
			toast.error(`Erro ao consultar Potêncial: ${err.message}`);
		} finally {
			this.setState({
				isLoading: false,
				activeIndex: null,
			});
		}
	};

	// Quota Articles
	handleGetQuotaArticles = async () => {
		this.setState({
			isLoading: true,
			articlesSelected: [],
			articlesOptions: [],
		});
		try {
			const { data } = await api.comercial.filters.quotaArticle.getAll();

			if (data.length === 0) {
				toast.warn('Nenhum artigo encontrado!');
				return;
			}

			const articlesOptions = data.map((article) => articleToOptions(article));

			this.setState({ articlesOptions, articlesSelected: articlesOptions });
		} catch (err) {
			toast.error(`Erro ao consultar Artigos de Cotas: ${err.message}`);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	calculatePercentualOfGoal = (value, goal) => {
		// goal = ex: cotaVendas.goal
		// value = ex: cotaVendas.sales

		if (goal !== 0 && value !== 0) {
			return parseFloat(((value / (goal / 2).toFixed(2)) * 100).toFixed(2));
		} else {
			return 100;
		}
	};

	calculateMaxValue = (value, goal) => {
		if (value >= goal && goal > 0) {
			return goal;
		} else {
			return value;
		}
	};

	transformCurrency = (labelValue) => {
		// Nine Zeroes for Billions
		return Math.abs(Number(labelValue)) >= 1.0e9
			? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(3) + 'B'
			: // Six Zeroes for Millions
			Math.abs(Number(labelValue)) >= 1.0e6
			? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(3) + 'M'
			: // Three Zeroes for Thousands
			Math.abs(Number(labelValue)) >= 1.0e3
			? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(3) + 'K'
			: Math.abs(Number(labelValue));
	};

	toBrCurrency = (x) => {
		const regex = x
			.toString()
			.replace('.', ',')
			.replace(/(\d)(?=(\d{3})+\,)/g, '$1.'); //eslint-disable-line
		return regex.split(',')[1]
			? regex.split(',')[1].length === 1
				? regex + '0'
				: regex
			: regex;
	};

	render() {
		const {
			// IsLoading
			isLoadingNp,
			isLoadingPt,
			isLoadingSg,
			// isLoadingSgp,
			// isLoadingRg,
			isLoadingWa,
			isLoadingCs,
			isLoadingCo,

			// Charts
			cotaVendas,
			cotaVendasPeriodo,
			cotaFaturamento,
			comissao,
			carteira,
			customerService,
			collection,

			// NonPayment
			nonPayment,

			// Quota Articles
			articlesOptions,
			articlesSelected,

			// Filters
			representante,
			searchedRepresentante,
			// searchedSupervisor,
			// suggestionPriority,
			requestDate,
			// isRepresentante = representante ? true : false,

			// Page State
			isLoading,
			// isSending,
			activeIndex,
		} = this.state;

		const isRepFilled =
			representante === 0 ? searchedRepresentante : representante;

		if (representante === '')
			return (
				<div
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Spinner size="xlarge" />
				</div>
			);

		return (
			<>
				<div className="acompVendas-container">
					<PrimeAccordion
						activeIndex={activeIndex}
						onTabChange={(e) => this.handleActiveIndex(e.index)}
						style={{ marginBottom: '0.8vh' }}
					>
						<AccordionTab header="Filtros">
							<Row>
								{representante === 0 && (
									<Col md={3}>
										<FormGroup>
											<FormLabel>Representante</FormLabel>
											<FormControl
												style={{ marginBottom: '20px' }}
												className="rounded-input"
												type="text"
												name="searchedRepresentante"
												value={searchedRepresentante}
												onChange={this.handleFieldChange}
												disabled={representante !== 0}
											/>
										</FormGroup>
									</Col>
								)}
								{
									<Col md={2}>
										<FormGroup>
											<FormLabel>Coleções</FormLabel>
											<Popout
												name="artigo"
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												isSearchable
												isClearable={true}
												maxDisplay={1}
												menuWidth={'100%'}
												options={articlesOptions}
												onChange={this.handleArticle}
												value={articlesSelected}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={2}>
										<FormGroup>
											<FormLabel style={{ marginBottom: '8px' }}>
												Mês e Ano
											</FormLabel>
											<DatePicker
												className="rounded-input form-control"
												selectsStart
												locale="ptBR"
												dateFormat="MM/yyyy"
												showMonthYearPicker
												startDate={requestDate}
												selected={requestDate}
												onChange={(e) =>
													this.handleDateChange('requestDate', e)
												}
											/>
										</FormGroup>
									</Col>
								}
								<Col md={3}>
									<div className="actions">
										<FormGroup style={{ marginTop: '29px' }}>
											<ButtonGroup>
												{
													<LoadingButton
														type="button"
														variant="success"
														title="Consultar"
														onClick={() =>
															this.handleChart(
																representante === 0
																	? searchedRepresentante
																	: representante,
															)
														}
														isLoading={isLoading}
													>
														{Button}
													</LoadingButton>
												}
												{
													<Button
														className="btn btn-secondary"
														onClick={this.handleClear}
													>
														Limpar
													</Button>
												}
											</ButtonGroup>
										</FormGroup>
									</div>
								</Col>
							</Row>
						</AccordionTab>
					</PrimeAccordion>
				</div>
				<Card className="card-indicadores">
					<Card.Body className="align-items-center">
						<ReactTooltip multiline class="toolTip" />
						<div className="indicadores-wrapper">
							<div className="indicadores-container">
								<SalesGoalWrapper
									metaVendas={cotaVendas}
									isLoadingSg={isLoadingSg}
								/>
								<IsLoadingDiv isLoading={isLoadingSg}>
									<WeeklySalesGoal dadosGrafico={cotaVendasPeriodo} />
								</IsLoadingDiv>

								<IsLoadingDiv isLoading={isLoadingCs}>
									<ServedCustomers customerService={customerService} />
								</IsLoadingDiv>

								<IsLoadingDiv isLoading={isLoadingNp}>
									<NonPayment
										nonPayment={nonPayment}
										transformCurrency={this.transformCurrency}
										tip={tips.inadimplencia}
									/>
								</IsLoadingDiv>
								<IsLoadingDiv isLoading={isLoadingPt && isRepFilled}>
									<Potential
										collection={collection}
										tip={tips.colecoes}
										toBrCurrency={this.toBrCurrency}
										isRepFilled={isRepFilled}
									/>
								</IsLoadingDiv>
								<IsLoadingDiv isLoading={isLoadingWa}>
									<Revenue cotaFaturamento={cotaFaturamento} />
								</IsLoadingDiv>
								<IsLoadingDiv isLoading={isLoadingWa}>
									<Wallet
										carteira={carteira}
										tip={tips.carteira}
										toBrCurrency={this.toBrCurrency}
									/>
								</IsLoadingDiv>
								<IsLoadingDiv isLoading={isLoadingCo}>
									<Commission
										comissao={comissao}
										tip={tips.comissao}
										toBrCurrency={this.toBrCurrency}
									/>
								</IsLoadingDiv>
							</div>
						</div>
					</Card.Body>
				</Card>
			</>
		);
	}
}

export default withUser(Charts);
